import React, { useState } from "react";
import { Droplets, Waves, Shield, Sparkles } from "lucide-react";
import BookConsultModal from "../BookConsultModal";
import wp1 from "../../assets/bathroom2.webp";
import wp2 from "../../assets/bathroom3.jpg";
import wp3 from "../../assets/bathroom4.jpg";
import wp4 from "../../assets/bathroom5.jpeg";
import wp5 from "../../assets/bathroom6.jpg";


const BathroomWaterproofingSpaAmber = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-[#fffaf3]">

      {/* CLEAN HERO */}
      <section className="relative py-28">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          
          <div>
            <span className="inline-block mb-4 px-4 py-1 rounded-full bg-amber-100 text-amber-700 text-sm">
              Bathroom Specialists
            </span>
            <h1 className="text-5xl font-serif font-semibold leading-tight text-gray-800">
              Luxury Bathroom  
              <span className="text-amber-600"> Waterproofing</span>
            </h1>
            <p className="mt-6 text-gray-600 text-lg">
              No more leakage, damp walls or bad smell.  
              Give your bathroom a hygienic & long-lasting protection.
            </p>

            <div className="mt-10 flex gap-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-amber-600 text-white px-8 py-3 rounded-full hover:bg-amber-700 transition"
              >
                Free Inspection
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-amber-600 text-amber-600 px-8 py-3 rounded-full hover:bg-amber-50 transition"
              >
                Talk to Expert
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-6 bg-amber-200/40 rounded-[3rem] blur-2xl" />
            <img
              src={wp1}
              className="relative rounded-[3rem] shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* PROBLEM STRIP */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 gap-10 text-center">
          {[
            { icon: <Droplets />, title: "Water Seepage" },
            { icon: <Waves />, title: "Damp Smell" },
            { icon: <Shield />, title: "Wall Damage" },
            { icon: <Sparkles />, title: "Mold Marks" },
          ].map((item, i) => (
            <div key={i} className="p-8 rounded-3xl bg-amber-50">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-amber-600 text-white flex items-center justify-center">
                {item.icon}
              </div>
              <p className="font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SPLIT STORY */}
      <section className="py-28">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
          <img src={wp2} className="rounded-[2.5rem] shadow-xl" />
          
          <div>
            <h2 className="text-4xl font-serif font-semibold text-gray-800">
              Why Bathroom Needs  
              Special Waterproofing?
            </h2>
            <p className="mt-6 text-gray-600 leading-relaxed">
              Bathrooms are high-moisture zones.  
              Regular paint or tiles are not enough.  
              Without proper waterproofing, water slowly enters walls and slabs.
            </p>

            <ul className="mt-8 space-y-3 text-gray-700">
              <li>✔ Prevents hidden leakage</li>
              <li>✔ Stops bad odor & fungus</li>
              <li>✔ Protects structure for years</li>
              <li>✔ Keeps tiles & fittings safe</li>
            </ul>
          </div>
        </div>
      </section>

      {/* GALLERY STRIP */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-serif font-semibold text-center mb-12">
            Real Bathroom Transformations
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {[wp3, wp4, wp5].map((img, i) => (
              <img
                key={i}
                src={img}
                className="rounded-3xl shadow-lg hover:scale-105 transition"
              />
            ))}
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
<section className="py-28 bg-[#fffaf3]">
  <div className="max-w-6xl mx-auto px-6 text-center">
    <h2 className="text-4xl font-serif font-semibold text-gray-800 mb-4">
      Our Bathroom Waterproofing Process
    </h2>
    <p className="text-gray-600 mb-16 max-w-2xl mx-auto">
      A systematic professional method for long-lasting and hygienic bathrooms.
    </p>

    <div className="grid md:grid-cols-4 gap-10">
      {[
        { step: "01", title: "Inspection", desc: "Moisture and leakage detection." },
        { step: "02", title: "Surface Prep", desc: "Deep cleaning & crack sealing." },
        { step: "03", title: "Chemical Coating", desc: "Premium waterproof layers." },
        { step: "04", title: "Final Testing", desc: "Water flow & leak testing." },
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white/70 backdrop-blur-xl rounded-3xl p-10 shadow-xl hover:-translate-y-2 transition"
        >
          <div className="text-amber-600 font-bold text-xl mb-3">
            {item.step}
          </div>
          <h3 className="font-semibold text-lg mb-2">
            {item.title}
          </h3>
          <p className="text-gray-600 text-sm">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
{/* SERVICES INCLUDED */}
<section className="py-28 bg-[#fffaf3]">
  <div className="max-w-6xl mx-auto px-6 text-center">
    <h2 className="text-4xl font-serif font-semibold mb-4">
      What’s Included In Our Service
    </h2>
    <p className="text-gray-600 mb-16 max-w-2xl mx-auto">
      Complete end-to-end waterproofing solution for your bathroom.
    </p>

    <div className="grid md:grid-cols-3 gap-10">
      {[
        "Leak Detection",
        "Crack Filling",
        "Tile Joint Sealing",
        "Chemical Coating",
        "Drain Area Protection",
        "Final Water Testing",
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-3xl p-10 shadow-xl hover:-translate-y-2 transition"
        >
          <div className="text-amber-600 text-3xl mb-4">✔</div>
          <p className="font-medium text-gray-700">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>
{/* FAQ SECTION */}
<section className="py-28 bg-white">
  <div className="max-w-5xl mx-auto px-6">
    <h2 className="text-4xl font-serif font-semibold text-center mb-16">
      Frequently Asked Questions
    </h2>

    <div className="space-y-8">
      {[
        {
          q: "How long does bathroom waterproofing last?",
          a: "Our professional waterproofing lasts 8–10 years with proper maintenance.",
        },
        {
          q: "Do I need to remove tiles?",
          a: "In most cases no. We use non-invasive chemical coating methods.",
        },
        {
          q: "How much time does the process take?",
          a: "Usually 1–2 days depending on bathroom size and condition.",
        },
        {
          q: "Is it safe for health?",
          a: "Yes, we use eco-friendly and non-toxic materials.",
        },
      ].map((item, i) => (
        <div key={i} className="bg-[#fffaf3] p-8 rounded-2xl">
          <h3 className="font-semibold text-lg mb-2">
            {item.q}
          </h3>
          <p className="text-gray-600">
            {item.a}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>

{/* TRUST STATS */}
<section className="py-24 bg-white">
  <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 text-center gap-12">
    {[
      { num: "300+", label: "Bathrooms Protected" },
      { num: "8+", label: "Years Experience" },
      { num: "100%", label: "Hygiene Guarantee" },
      { num: "10 yrs", label: "Waterproofing Life" },
    ].map((item, i) => (
      <div key={i}>
        <h3 className="text-4xl font-bold text-amber-600 mb-2">
          {item.num}
        </h3>
        <p className="text-gray-600">
          {item.label}
        </p>
      </div>
    ))}
  </div>
</section>


      {/* PREMIUM FLOATING CTA */}
<section className="relative py-32 bg-[#fffaf3] overflow-hidden">
  {/* Background gradient blobs */}
  <div className="absolute -top-32 -left-32 w-96 h-96 bg-amber-200/30 rounded-full blur-3xl"></div>
  <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl"></div>

  <div className="relative max-w-4xl mx-auto px-6">
    <div className="bg-white/70 backdrop-blur-xl border border-white/30 rounded-[3rem] p-16 text-center shadow-[0_40px_120px_-30px_rgba(0,0,0,0.25)] transition-transform hover:-translate-y-2 hover:shadow-[0_50px_150px_-40px_rgba(0,0,0,0.35)]">
      
      <span className="inline-block mb-4 px-5 py-1 rounded-full bg-amber-100 text-amber-700 text-sm tracking-wide">
        Free Expert Visit
      </span>

      <h2 className="text-4xl md:text-5xl font-serif font-semibold text-gray-800 mb-4">
        Your Bathroom Deserves  
        <span className="text-amber-600"> Premium Protection</span>
      </h2>

      <p className="text-gray-600 max-w-xl mx-auto mb-10 text-lg leading-relaxed">
        Hidden leaks can damage walls & floors.  
        Schedule a free visit & get a professional waterproofing plan.
      </p>

      <div className="flex justify-center gap-4">
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-10 py-4 bg-gradient-to-r from-amber-500 to-amber-700 text-white rounded-full font-semibold shadow-lg hover:scale-105 transition"
        >
          Book Free Inspection
        </button>

        <button
          onClick={() => setIsModalOpen(true)}
          className="px-10 py-4 border border-amber-600 text-amber-700 rounded-full hover:bg-amber-50 transition"
        >
          Talk to Expert
        </button>
      </div>
    </div>
  </div>
</section>


      <BookConsultModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default BathroomWaterproofingSpaAmber;
